import { useState, useEffect } from "react";
import { Cookie, X } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

const STORAGE_KEY = "nexus_cookie_accepted_v1";

export default function CookieBanner() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!localStorage.getItem(STORAGE_KEY)) {
            const t = setTimeout(() => setVisible(true), 800);
            return () => clearTimeout(t);
        }
    }, []);

    const accept = () => {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({ accepted_at: Date.now() }));
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div
            data-testid="cookie-banner"
            className="fixed bottom-4 left-4 right-4 md:left-6 md:right-6 lg:left-auto lg:right-6 lg:max-w-md z-50 glass-panel border-electric-blue/40 p-5 animate-fade-up"
            role="dialog"
            aria-label="Cookie consent"
        >
            <div className="flex items-start gap-3">
                <div className="flex-shrink-0 w-9 h-9 bg-electric-blue/15 border border-electric-blue/40 flex items-center justify-center">
                    <Cookie size={16} weight="duotone" className="text-electric-blue" />
                </div>
                <div className="flex-1 min-w-0">
                    <p className="label-mono text-electric-blue mb-2 text-[10px]">SYNDICATE COOKIES</p>
                    <p className="text-xs text-foreground/85 leading-relaxed mb-4">
                        We use cookies to keep you logged in and remember your preferences. By continuing to
                        use the Lab you agree to our{" "}
                        <Link to="/terms" data-testid="cookie-terms-link" className="text-electric-blue hover:underline">Terms</Link>{" "}
                        and{" "}
                        <Link to="/privacy" data-testid="cookie-privacy-link" className="text-electric-blue hover:underline">Privacy Policy</Link>.
                    </p>
                    <div className="flex items-center gap-2">
                        <button
                            data-testid="cookie-accept-btn"
                            onClick={accept}
                            className="bg-electric-blue hover:bg-electric-blue-dark text-white text-xs font-bold tracking-wider uppercase px-4 py-2 transition-all hover:shadow-[0_0_18px_rgba(0,123,255,0.45)]"
                        >
                            Accept
                        </button>
                        <Link
                            to="/privacy"
                            data-testid="cookie-learn-link"
                            className="label-mono text-[10px] text-muted-foreground hover:text-white transition-colors"
                        >
                            LEARN MORE
                        </Link>
                    </div>
                </div>
                <button
                    data-testid="cookie-dismiss-btn"
                    onClick={accept}
                    aria-label="Dismiss"
                    className="text-muted-foreground hover:text-white"
                >
                    <X size={14} />
                </button>
            </div>
        </div>
    );
}
